export default __webpack_public_path__ + "static/media/qr-create-vc-prod.301bd372.png";